import DocumentRepository from "../";
const routes = [
  {
    name: "Document Repository",
    path: "/documentrepository",
    component: DocumentRepository.DocumentRepositoryList,
    meta: { title: "Document" },
  },
  {
    name: "Document Repository Detail",
    path: "/documentrepository/view/:id",
    component: DocumentRepository.DocumentRepositoryDetail,
    meta: { title: "Document Detail" },
  }
];
export default routes;
